import { useDispatch, useSelector } from "react-redux";
import { Button, Card, Col, Row, Spin, Typography, message } from "antd";
import { SyncOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { initiateInitialExtraction } from "../../../redux/adminSlice";
import { fetchSTBusinessUnits } from "../../../redux/organizationSlice";

const { Title, Text } = Typography;

const HouseCallProDetails = () => {
  const dispatch = useDispatch();
  const {
    organizationData,
    serviceTitanJobs,
    loading,
    serviveTitanLoading,
  } = useSelector((state) => state?.organization);
  const { isAdmin, currentOrganizationId } = useSelector(
    (state) => state?.auth
  );


  const [isSyncing, setIsSyncing] = useState(false);

  useEffect(() => {
    dispatch(fetchSTBusinessUnits(currentOrganizationId));
  }, [dispatch, currentOrganizationId]);

  const handleSyncData = async () => {
    if (!organizationData?.apiKeys?.st_tenant_id) {
      message.error('Please configure Tenant ID in API Keys section first');
      return;
    }
    setIsSyncing(true);
    await dispatch(initiateInitialExtraction(organizationData?._id));
    setIsSyncing(false);
  };

  const hasTenantId = organizationData?.apiKeys?.st_tenant_id;

  return (
    <>
      <Spin spinning={loading || serviveTitanLoading || isSyncing} fullscreen />
      <Card
        style={{
          background: "gray",
          borderRadius: "15px",
          marginBottom: "30px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Row align="middle" justify="space-between">
          <Col>
            <Title
              level={4}
              style={{
                margin: 0,
                color: "#fff",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src="https://static-assets.housecallpro.com/brand/logos/square-door-only.svg"
                alt="HouseCallPro Logo"
                style={{ width: "40px", height: "40px" }}
              />
              House Call Pro Job Types
            </Title>
          </Col>
          {isAdmin && (
            <Col>
              <Button
                type="dashed"
                shape="round"
                icon={<SyncOutlined spin={isSyncing} />}
                onClick={handleSyncData}
                loading={isSyncing}
                style={{ 
                  background: "rgba(255, 255, 255, 0.1)", 
                  color: "white",
                  opacity: hasTenantId ? 1 : 0.5
                }}
                disabled={loading || serviveTitanLoading || isSyncing || !hasTenantId}
                className="custom-dashed-button"
              >
                {hasTenantId ? 'Sync Data' : 'Configure Tenant ID First'}
              </Button>
            </Col>
          )}
        </Row>
      </Card>

      <Row>
        <Col span={24}>
          <Card
            title="Job Types"
            bordered={false}
            style={{
              borderRadius: "10px",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
            }}
          >
            {serviceTitanJobs?.length > 0 ? (
              serviceTitanJobs.map((job, index) => (
                <div
                  key={index}
                  style={{
                    borderBottom:
                      index !== serviceTitanJobs.length - 1
                        ? "1px solid #f0f0f0"
                        : "none",
                    padding: "10px 0",
                  }}
                >
                  <Text
                    strong
                    style={{
                      color: "#595959",
                    }}
                  >
                    {job?.name}
                  </Text>
                </div>
              ))
            ) : (
              <Text type="secondary">No Job Types Available</Text>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default HouseCallProDetails;
